import React from 'react'

const Footer = () => {
    return (
        <>
        <footer>
            <div >
                <div className='container d-flex flex-wrap justify-content-around pt-5'>
                    <div className='text-left'>
                        <h4>Infromation</h4>
                        <ul className="list-unstyled">
                            <li>About Us</li>
                            <li>Information</li>
                            <li>Privacy Policy</li>
                            <li>Terms & Conditions</li>
                        </ul>
                    </div>
                    <div className='text-left'>
                        <h4>Service</h4>
                        <ul className="list-unstyled">
                            <li>About Us</li>
                            <li>Information</li>
                            <li>Privacy Policy</li>
                            <li>Terms & Conditions</li>
                        </ul>
                    </div>
                    <div className='text-left'>
                        <h4>Extras</h4>
                        <ul className="list-unstyled">
                            <li>About Us</li>
                            <li>Information</li>
                            <li>Privacy Policy</li>
                            <li>Terms & Conditions</li>
                        </ul>
                    </div> 
                    <div className='text-left'>
                        <h4>My Account</h4>
                        <ul className="list-unstyled">
                            <li>About Us</li>
                            <li>Information</li>
                            <li>Privacy Policy</li>
                            <li>Terms & Conditions</li>
                        </ul>
                    </div> 
                    <div className='text-left'>
                        <h4>Userful Links</h4>
                        <ul className="list-unstyled">
                            <li>About Us</li>
                            <li>Information</li>
                            <li>Privacy Policy</li>
                            <li>Terms & Conditions</li>
                        </ul>
                    </div> 
                    <div className='text-left'>
                        <h4>Userful Links</h4>
                        <ul className="list-unstyled">
                            <li>About Us</li>
                            <li>Information</li>
                            <li>Privacy Policy</li>
                            <li>Terms & Conditions</li>
                        </ul>
                    </div>
                </div>
                <div className='container text-right py-2'>
                    <img src='assets\images\Web\Western_union.svg' alt='Logo' className='p-1' style={{width: 50}}/> 
                    <img src='assets\images\Web\master_card.svg' alt='Logo' className='p-1' style={{width: 50}}/> 
                    <img src='assets\images\Web\Paypal.svg' alt='Logo' className='p-1' style={{width: 50}}/> 
                    <img src='assets\images\Web\visa.svg' alt='Logo' className='p-1' style={{width: 50}}/> 
                </div>
            </div>
            <div className='text-right lead'>- Sanjeet...</div>
        </footer>
      </> 
    )
}

export default Footer
